<ng-template ngIf="headerToolTemplate">
    <div class="dr-popup-top-tool-container">
        <div *ngTemplateOutlet="headerToolTemplate;context:context">
        </div>
    </div>
</ng-template>

<div class="nos dr-popup-calendar-container">
    <div class="container-fluid dr-popup-tool">
        <div class="dr-popup-picker-container">
            <div>
                <div mwlCalendarPreviousView [view]="view" class="dr-popup-previous-btn" [viewDate]="viewDate" (viewDateChange)="viewDateChange($event)">
                    <i class="fa fa-chevron-left poi"></i>
                </div>
    
            </div>
            <div class="dr-title">
                <span class="com-title-month" (click)="showMonthPopup=true;">{{viewDate | date:'MMMM' }}</span><span class="com-title-year" (click)="showYearPopup=true;">{{viewDate|date:'yyyy'}}</span>
                <!-- {{viewDate | calendarDate:'monthViewTitle':'en'}} -->
                
            </div>
            <div>
                <div mwlCalendarNextView [view]="view" class="dr-popup-next-btn" [viewDate]="viewDate" (viewDateChange)="viewDateChange($event)">
                    <i class="fa fa-chevron-right poi"></i>
                </div>
            </div>
        </div>
    </div>
    <mwl-calendar-month-view #calendar [viewDate]="viewDate" (dayClicked)="dayClick($event.day)"
        (beforeViewRender)="beforeMonthViewRender($event)">
    </mwl-calendar-month-view>
    <div class="com-month-year-popup" *ngIf="showMonthPopup||showYearPopup">
        <ad-month-picker *ngIf="showMonthPopup" (onSelect)="monthSelect($event)"></ad-month-picker>
        <ad-year-picker *ngIf="showYearPopup" (onSelect)="yearSelect($event)" [currentDate]="viewDate"></ad-year-picker>
    </div>
</div>
<ng-template ngIf="footerToolTemplate">
    <div class="dr-popup-bottom-tool-container">
        <div *ngTemplateOutlet="footerToolTemplate;context:context"></div>
    </div>
</ng-template>